// Create QR Code when page loads
document.addEventListener('DOMContentLoaded', function () {
  const codeElements = document.getElementsByClassName('qrcode')
  if (codeElements.length > 0) {
    // for any of the QR code images, you can have a button and blurrer anywhere on the page
    // as long as the share the data-id attribute.
    // these then create an interation.
    // for this to work, you also need to add the qrcode-interactive class to the qrcode element

    const hoverQRButtons = document.getElementsByClassName('qr-hover')
    const blurElements = document.getElementsByClassName('qrcode-blur')
    // Get current page URL

    for (let i = 0; i < codeElements.length; i++) {
      const codeElement = codeElements[i]
      // Create QR Code
      addQrCodeToElement(codeElement)
      const isInteractive = codeElement.classList.contains('qrcode-interactive')
      if (!isInteractive) {
        continue
      }

      // add the interactive stuff
      const hoverQRButton = Array.from(hoverQRButtons).find(
        button => button.getAttribute('data-id') === codeElement.dataset.id
      )

      const blurElement = Array.from(blurElements).find(
        element => element.getAttribute('data-id') === codeElement.dataset.id
      )

      hoverQRButton.addEventListener('click', function () {
        codeElement.classList.toggle('show')
        blurElement.classList.toggle('show')
      })

      blurElement.addEventListener('click', function () {
        codeElement.classList.toggle('show')
        blurElement.classList.toggle('show')
      })
    }
  }

  function addQrCodeToElement (codeElement) {
    // Create QR Code
    new QRCode(codeElement, {
      text: window.location.href,
      width: 256,
      height: 256,
      colorDark: '#000000',
      colorLight: '#ffffff',
      correctLevel: QRCode.CorrectLevel.H
    })
  }
})
